import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

if (process.env.REACT_APP_CLIENT_ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn: 'https://a5ff3609e16956f3b2e832af03c1a5b3@o4507887962619904.ingest.us.sentry.io/4507926968336384',
    environment: process.env.REACT_APP_CLIENT_ENVIRONMENT,
    release: '0.1.0',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
